import { FC } from 'react';

import ScrollPhoneSlider from '@/components/ScrollPhoneSlider/ScrollPhoneSlider';

import PhoneSlider from './PhoneSlider';

const ChatbotScrollSlider: FC<any> = ({ data }) => (
	<ScrollPhoneSlider
		title={data?.title}
		slides={data?.contentBlock}
		description={data?.description}
		buttonText={data?.cta?.text}
		buttonLink={data?.cta?.link}
		buttonImage={data?.buttonImage}
		PhoneSlider={PhoneSlider}
	/>
);

export default ChatbotScrollSlider;
